import {
  api_url
} from '../config.js';
import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home.vue'
import detail from '../views/detail.vue'
import detail1 from '../views/detail1.vue'
import shop from '../views/shop.vue'
import fangancart from '../views/fangancart.vue'
import fangandetail from '../views/fangandetail.vue'
import axios from 'axios'
import { resolveAlbumRoute } from '../utils/album-entry'
import { albumAccess } from '../utils/album-access'
Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [{
    path: '/access-error',
    name: 'access-error',
    redirect: function(to) {
      var target = to.query.target || '/';
      return typeof target === 'string' && target.charAt(0) === '/' && target.indexOf('//') !== 0 && target.indexOf('/access-error') !== 0 ? target : '/';
    }
  }, {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      //isUseCache: true, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
      title: '首页'

    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '商品详情'

    }
  },
  {
    path: '/detail1',
    name: 'detail1',
    component: detail1,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '商品详情'

    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: shop,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '礼册详情'

    }
  },
  {
    path: '/fangancart',
    name: 'fangancart',
    component: fangancart,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '采购蓝'

    }
  },
  {
    path: '/fangandetail',
    name: 'fangandetail',
    component: fangandetail,
    meta: {
      //isUseCache: true, // 默认不缓存
      //keepAlive: true ,// 是否使用 keep-alive
      title: '采购详情'

    }
  }
  ],


})

function resolveEntry(to) {
  return resolveAlbumRoute(to, window.location.hostname, function(params) {
    return axios.get(api_url, {params: params, timeout: 15000});
  });
}
function accessMessage(error) {
  return error.response || error.code === 'ECONNABORTED' || error.message === 'Network Error' ? '画册服务暂不可用，请稍后重试' : error.message || '画册暂时无法访问';
}
router.beforeEach(function(to, from, next) {
  // 同一画册内切换分类等查询参数时直接更新路由，避免重新解析入口并触发整页加载遮罩。
  if (from.name && to.path === from.path && String(to.query.id || '') === String(from.query.id || '')) {
    next();
    return;
  }

  albumAccess.pending = true;
  albumAccess.error = '';
  resolveEntry(to).then(function(route) {
    if (route.standalone || String(to.query.id || '') === route.query.id) {
      albumAccess.pending = false;
      albumAccess.ready = true;
      next();
    } else next(route);
  }).catch(function(error) {
    albumAccess.pending = false;
    albumAccess.ready = false;
    albumAccess.error = accessMessage(error);
    // 保留请求地址，由 App 展示错误提示，禁止业务组件继续加载。
    next();
  });
});

export function retryAlbumAccess() {
  if (albumAccess.pending) return;
  albumAccess.pending = true;
  albumAccess.ready = false;
  albumAccess.error = '';
  return resolveEntry(router.currentRoute).then(function(route) {
    if (!route.standalone && String(router.currentRoute.query.id || '') !== route.query.id) router.replace(route);
    else { albumAccess.pending = false; albumAccess.ready = true; }
  }).catch(function(error) {
    albumAccess.pending = false;
    albumAccess.error = accessMessage(error);
  });
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js